import { Navigate, Outlet } from "react-router-dom";
import toastNotify from "../utils/ToastNotify";
var CryptoJS = require("crypto-js");

const decryptingData = () => {
  var aTokenBytes = sessionStorage.getItem("__atoken_") ? CryptoJS.AES.decrypt(
    sessionStorage.getItem("__atoken_"),
    process.env.REACT_APP_CRYPTO_SECRET_KEY
  ) : null;
  var decryptedAccessToken = aTokenBytes && JSON.parse(
    aTokenBytes.toString(CryptoJS.enc.Utf8)
  );

  var rTokenBytes = sessionStorage.getItem("__rtoken_") ? CryptoJS.AES.decrypt(
    sessionStorage.getItem("__rtoken_"),
    process.env.REACT_APP_CRYPTO_SECRET_KEY
  ) : null;
  var decryptedRefreshToken = rTokenBytes && JSON.parse(
    rTokenBytes.toString(CryptoJS.enc.Utf8)
  );

  var userBytes = sessionStorage.getItem("__user_") ? CryptoJS.AES.decrypt(
    sessionStorage.getItem("__user_"),
    process.env.REACT_APP_CRYPTO_SECRET_KEY
  ) : null;

  var decryptedUserData = userBytes && JSON.parse(userBytes.toString(CryptoJS.enc.Utf8));

  return { decryptedAccessToken, decryptedUserData, decryptedRefreshToken };
};

export function encryptValue(val) {
  return CryptoJS.AES.encrypt(
    JSON.stringify(val),
    process.env.REACT_APP_CRYPTO_SECRET_KEY
  ).toString();
}

export function decryptValue(val) {
  var data = CryptoJS.AES.decrypt(val, process.env.REACT_APP_CRYPTO_SECRET_KEY);
  return data.sigBytes !== 0 ? JSON.parse(data.toString(CryptoJS.enc.Utf8)) : "";
}

export const removeLoginSession = () => {
  sessionStorage.clear();
};

export function getLocalAccessToken() {
  const { decryptedAccessToken } = decryptingData();
  return decryptedAccessToken;
}

export function getLocalRefreshToken() {
  const { decryptedRefreshToken } = decryptingData();
  return decryptedRefreshToken;
}

export function getClientData() {
  try {
    const { decryptedUserData } = decryptingData();
    return decryptedUserData;
  } catch (error) {
    return null;
  }
}

// Get login timestamp from local storage
export const getLoginTimestamp = () => localStorage.getItem("loginTimestamp");

// Set login timestamp in local storage
export const setLoginTimestamp = (timestamp) =>
  localStorage.setItem("loginTimestamp", timestamp);

// uploaded Image/PDF Download
export function downloadUploadedItem(url, filename) {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      // Handle FileReader errors
      reject(error);
      toastNotify("Error reading file.", "error");
    };
  });
};

export function setLocalRefreshToken(val) {
  var cipherRefreshTokenText = CryptoJS.AES.encrypt(
    JSON.stringify(val),
    process.env.REACT_APP_CRYPTO_SECRET_KEY
  ).toString();
  return sessionStorage.setItem("__rtoken_", cipherRefreshTokenText);
}

export function setLocalAccessToken(val) {
  var cipherAccessTokenText = CryptoJS.AES.encrypt(
    JSON.stringify(val),
    process.env.REACT_APP_CRYPTO_SECRET_KEY
  ).toString();
  return sessionStorage.setItem("__atoken_", cipherAccessTokenText);
}

export function setUserData(val) {
  var cipherUserText = CryptoJS.AES.encrypt(
    JSON.stringify(val),
    process.env.REACT_APP_CRYPTO_SECRET_KEY
  ).toString();
  return sessionStorage.setItem("__user_", cipherUserText);
}

export function PrivateOutlet() {
  const isAuthenticated = getLocalAccessToken();
  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
}

// here set ip in localstorage
export const setIdentityData = async () => {
  try {
    const ipV4 = await (await fetch("https://ip.stconnect.in:6789/api/myip/json"))?.json();
    if (ipV4) {
      localStorage.setItem("_identityData", JSON.stringify(ipV4));
    }
    return ipV4;
  } catch {
    return "";
  }
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const getIsAutheticate = () => {
  const userData = sessionStorage.getItem('__atoken_');
  return Object.is(userData, null) === false
}


export const AuthKey = "Basic " + process.env.REACT_APP_BASIC_AUTH_KEY;

export const encData = (data) => {
  const SECRET_KEY = process.env.REACT_APP_ENC_KEY;
  const key = CryptoJS.enc.Utf8.parse("CRMSCLIENTAPI223");
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString(); // Returns a Base64 string
};
